module.exports = __webpack_public_path__ + "static/media/sfl_9.f64e6495.jpg";